// Allows the introspectionResult to be imported as a named symbol
export { default as introspectionResult } from './introspection-result';
